import { useMemo } from "react";
import FormulaLabel from "../FormulaLabel/FormulaLabel";
import { FormulaSelect } from "../FormulaSelect";
import { filteredObjectByValueTypes } from "../helpers/filteredObjectByValueTypes";

const OperatorComponent = ({
  node,
  onUpdateItem,
  dropdownData,
  onDeleteItem,
  onSelectHandler,
}) => {
  const onSelect = (item) => {
    onSelectHandler(item, { currentNodeId: node.id });
  };

  const { nextValueType } = node;

  const dataForInputs = useMemo(() => {
    return filteredObjectByValueTypes({
      object: dropdownData,
      valueTypes: nextValueType,
    });
  }, [dropdownData, nextValueType]);

  return (
    <>
      <FormulaLabel key={node.key} onDeleteItem={onDeleteItem} onUpdateItem={onUpdateItem} node={node} />

      <FormulaSelect
        isActive={true}
        onSelectItem={onSelect}
        dropdownData={dataForInputs}
      />
    </>
  );
};

export default OperatorComponent;
